import {Person} from '../person/person';

export class UserApplication {

  id!: number;
  userName!: string;
  firstName!: string;
  lastName!: string;
  company!: string;
  jobTitle!: string;
  workEmail!: string;
  phoneNumber!: string;
  supervisor!: Person;
  personRecord!: Person;

}
